module.exports = __webpack_public_path__ + "img/LOGO_PMVV_2021.6fbdcdf3.png";